import { render, staticRenderFns } from "./UsageDataHostDetailPage.vue?vue&type=template&id=0e96a24b&scoped=true"
import script from "./UsageDataHostDetailPage.vue?vue&type=script&lang=js"
export * from "./UsageDataHostDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96a24b",
  null
  
)

export default component.exports